import React from 'react';
import { Card } from 'react-bootstrap';

const Article = (props) => {
    const {blog:{title,shortDescription,thumbnail,link,date,tags}} = props;
    return (
        <Card 
        style={{backgroundColor:"#172a45"}}
        >
            <a className="blog-link" target="_blank" rel="noreferrer" href={link}>
            <article>
                <Card.Img variant="top" src={thumbnail} />
                <Card.Body>
                    <Card.Title>{title}</Card.Title>
                    <Card.Text className="small">
                    {shortDescription}
                    </Card.Text>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex justify-content-between">
                        <div className="technology">
                            {
                                tags.map(tag =>  <span>{tag}</span>)
                            }
                        </div>
                        <p>{date}</p>
                    </div>
                </Card.Footer>
            </article>
            </a>
        </Card>

    );
};

export default Article;